import React, { useRef, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../App.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "../axios/axios";

const UploadPage = () => {
  const navigate = useNavigate();
  // get query params
  const query = new URLSearchParams(window.location.search);
  const type = query.get("type");
  // get id from params
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("upload");
  const [link, setLink] = useState("");
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const fileInputRef = useRef(null);

  const updateDriveLink = async () => {
    let url = `/color-correction/${id}`;
    if (type === "real-estate") {
      url = `/real-estate/${id}`;
    } else if (type === "video-editing") {
      url = `/video-editing/${id}`;
    } else if (type === "culling") {
      url = `/culling/${id}`;
    } else if (type === "album-design") {
      url = `/wedding-album/${id}`;
    } else if (type === "retouching") {
      url = `/retouching/${id}`;
    }

    try {
      await axios.put(url, {
        drive_link: link,
      });
      toast.success("Link Updated Successfully");
      navigate("/user-dashboard");
    } catch (error) {
      console.log(error);
      toast.error("Failed to update link");
    }
  };

  const handleAddFilesClick = () => {
    fileInputRef.current?.click();
  };

  const handleFilesSelected = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const formData = new FormData();
    formData.append("id", id);
    formData.append("type", type || "color-correction");
    files.forEach((file) => formData.append("images", file));

    setUploading(true);
    setProgress(0);
    try {
      await axios.post("/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (event) => {
          if (event.total) {
            setProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      });
      toast.success("Files uploaded successfully");
      navigate("/user-dashboard");
    } catch (error) {
      console.log(error);
      toast.error("Failed to upload files");
    } finally {
      setUploading(false);
      setProgress(0);
      // allow re-selecting the same file(s) again
      e.target.value = "";
    }
  };

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="d-flex justify-content-center mb-4">
          <div className="nav nav-tabs border-0 gap-x-2">
            <button
              className={`nav-link text-dark fw-bold border-0 bg-transparent me-2 ${
                activeTab === "upload" ? "active" : ""
              }`}
              style={{
                borderBottom:
                  activeTab === "upload" ? "2px solid #ffc107" : "none",
              }}
              onClick={() => setActiveTab("upload")}
            >
              Upload Files
            </button>
            <button
              className={`nav-link text-dark fw-bold border-0 bg-transparent ${
                activeTab === "addlink" ? "active" : ""
              }`}
              style={{
                borderBottom:
                  activeTab === "addlink" ? "2px solid #ffc107" : "none",
              }}
              onClick={() => setActiveTab("addlink")}
            >
              Add Link
            </button>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="bg-light rounded-3 p-4 mb-4 shadow-sm">
              <div className="mb-2">
                <span className="fw-bold">Your order:</span>{" "}
                <span className="fw-bold text_maincolor">ID {id}</span>
              </div>
            </div>
            {activeTab === "upload" && (
              <div className="d-flex flex-column align-items-center gap-3">
                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  onChange={handleFilesSelected}
                  style={{ display: "none" }}
                />
                <button
                  onClick={handleAddFilesClick}
                  disabled={uploading}
                  className="btn bg_maincolor text-white px-5 py-2 rounded-2 fw-bold"
                  style={{ fontSize: "1.1rem" }}
                >
                  {uploading ? `Uploading... ${progress}%` : "+ Add files"}
                </button>
                <small className="text-muted">
                  Files are uploaded to your order's Google Drive folder.
                </small>
              </div>
            )}
            {activeTab === "addlink" && (
              <div className="d-flex gap-3 justify-content-center">
                <textarea
                  className="form-control"
                  placeholder="Paste Link of Google drive, Dropbox, WeTransfer Etc.."
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                ></textarea>
                <button
                  onClick={updateDriveLink}
                  className="btn bg_maincolor text-white px-5 py-2 rounded-2 fw-bold"
                  style={{ fontSize: "1.1rem" }}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UploadPage;
